export default __webpack_public_path__ + "static/media/covidtracker.5ab881ec.jpg";